import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MessageItemProps } from "apis/message";
import { PaginationProps } from "utils/types/API";

export interface MessageState {
    loading: boolean;
    list: {
        data: MessageItemProps[];
        options: MessageItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: MessageItemProps;
    };
}

const initialState: MessageState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: MessageItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: MessageItemProps;
}
export const messageSlice = createSlice({
    name: "message",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = messageSlice.actions;
export default messageSlice.reducer;
